import { useCapabilityContext } from '../contexts/CapabilityContext';

const useCapabilities = () => useCapabilityContext();

export default useCapabilities;
